export default {
  title_single: 'This task already exists. What do you want to do?',
  title_multiple: 'These tasks already exist. What do you want to do?',
  subtitle_single: 'all other tasks were already created',
  create: 'Create anyway',
  edit: 'Edit what already exists'
}
